<template>
  <div>
    <div class="h-100">
      <b-navbar
        class="border-bottom shadow-sm"
        toggleable="sm"
        type="light"
        variant="light"
        :sticky="true">
        <b-navbar-toggle target="nav-text-collapse" />

        <b-collapse
          id="nav-text-collapse"
          is-nav>
          <b-navbar-nav class="ml-auto">
            <announcement-bell />
            <b-nav-item-dropdown
              id="user"
              right>
              <template slot="button-content">
                <span class="user-icon">
                  <v-icon
                    v-if="adminRole"
                    name="user-cog" />
                  <v-icon
                    v-else-if="hasRole('WRITE_DIAGNOSTIC')"
                    name="user-md" />
                  <v-icon
                    v-else
                    name="user-circle" />
                </span>
                <em>{{ getUserName }}</em>
              </template>
              <b-dropdown-item
                href="#"
                @click="logout()">
                {{ $t('app.navbar.logoutButtonText') }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
      <div class="genefox-logo-container">
        <img
          src="@/assets/images/genefox-print_couleur-XL.png"
          class="d-inline-block align-top is-hover genefox-logo"
          :alt="$t('app.navbar.title')"
          @click="$router.push({ name: 'run-list' })">
      </div>
      <div class="genefox-logo-container">
        <p class="version">
          {{ getVersionInfo() }}
        </p>
      </div>
      <announcement />
      <div class="content">
        <router-view />
      </div>
    </div>

    <app-left-sidebar />

    <app-release-note-modal
      ref="releaseNoteModal"
      :release="release"
      :not-seen="true"
      :ok-button-name="$t('common.ok')" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import SecurityMixin from './mixins/SecurityMixin';
import NotificationMixin from './mixins/NotificationMixin';
import LeftSidebar from '@/components/menu/LeftSidebar';
import { getLastRelease, getLastReleaseIfNotSeen } from '@/service/GenefoxService';
import ReleaseNoteModal from '@/components/common/ReleaseNoteModal';
import Announcement from '@/components/announcement/Announcement.vue';
import AnnouncementBell from './components/announcement/AnnouncementBell.vue';

export default {
  components: {
    AnnouncementBell,
    Announcement,
    'app-left-sidebar': LeftSidebar,
    'app-release-note-modal': ReleaseNoteModal
  },
  mixins: [
    SecurityMixin,
    NotificationMixin
  ],
  data: () => ({
    release: undefined
  }),
  computed: {
    getUserName() {
      return this.userName();
    },
    adminRole() {
      return this.hasRole('QA_ADMIN') || this.hasRole('R&D_ADMIN') || this.hasRole('SALES_ROLE');
    }
  },
  mounted() {
    return new Promise((resolve, reject) => {
      getLastReleaseIfNotSeen()
        .then(release => {
          if (release) {
            this.release = release;
            this.$refs.releaseNoteModal.showModal();
            resolve(release);
          }
        })
        .then(() => {
          if (!this.release) {
            return new Promise((resolve, reject) => {
              getLastRelease()
                .then(release => {
                  if (release) {
                    this.release = release;
                    resolve(release);
                  }
                })
                .catch(error => {
                  reject(error);
                });
            });
          }
        })
        .then(() => {
          this.$store.dispatch('laboratory/getCurrentConfiguration');
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  methods: {
    ...mapActions('security', [
      'logout'
    ]),
    getVersionInfo() {
      let info = `v ${this.release?.version}`;
      if (info.includes('latest') || info.includes('SNAPSHOT')) {
        info += ` algo v${this.release?.algoVersion} `;
      }

      return info;
    }
  }
};
</script>